<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex>
                <v-card>
                    <v-card-title primary-title>
                        <div class="headline">Avance Curricular</div>
                    </v-card-title>
                    <v-card-text>
                        <v-layout>
                            <v-flex v-for="(materias, semestre) in reticula" :key="semestre">
                                <v-card flat>
                                    <v-card-title class="pa-0">
                                        <h4>Semestre: {{semestre}}</h4>
                                    </v-card-title>
                                    <v-card-text class="pa-0">
                                        <div v-for="materia in materias" class="mt-1 pa-1 caption materia" :class="getColores(materia)">
                                            <b>{{materia.materia.clave}}</b><br>
                                            <span v-html="materia.materia.nombre"></span><br>
                                            <span v-if="materia.calificacion != 0 && getColores(materia) === 'teal white--text'">
                                            {{materia.calificacion}}/
                                            {{materia.tipoEvaluacion}}
                                            </span>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex>
                <v-card>
                    <v-card-title>
                        <h4>Código de Colores</h4>
                    </v-card-title>
                    <v-card-text>
                        <v-layout>
                            <v-flex sm12 md2>
                                <div class="materia pa-3 teal white--text">
                                    Acreditada
                                </div>
                            </v-flex>
                            <v-flex sm12 md2>
                                <div class="materia pa-3 deep-purple darken-1 white--text">
                                    Cursando
                                </div>
                            </v-flex>
                            <v-flex sm12 md2>
                                <div class="materia pa-3 yellow">
                                    Cursada Sin Acreditar Prioridad para seleccionar
                                </div>
                            </v-flex>
                            <v-flex sm12 md2>
                                <div class="materia pa-3 orange">
                                    A curso especial
                                </div>
                            </v-flex>
                            <v-flex sm12 md2>
                                <div class="materia pa-3 red white--text">
                                    Curso Especial Reprobado
                                </div>
                            </v-flex>
                            <v-flex sm12 md2>
                                <div class="materia pa-3 blue darken-3 white--text">
                                    Materia posible a seleccionar si requisitos OK
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-dialog v-model="cargandoDatos" max-width="280px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Cargando Avance Reticular</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'AvanceReticularPage',
    data: () => ({
      cargandoDatos: false,
      reticula: []
    }),
    mounted () {
      this.getAvanceReticular()
    },
    methods: {
      getAvanceReticular () {
        this.cargandoDatos = true
        axios.get('alumno/avance-reticular')
          .then(response => {
            this.cargandoDatos = false
            this.reticula = response.data
          })
      },
      getColores (materia) {
        let color = 'teal white--text'
        if (materia.tipoEvaluacion === '') {
          color = 'blue darken-3 white--text'
        }

        if (materia.calificacion === 0) {
          color = 'yellow'
        }

        if (materia.calificacion === 0 && materia.tipoEvaluacion === 'RO') {
          color = 'orange'
        }

        if (materia.calificacion === 0 && materia.tipoEvaluacion === 'CE') {
          color = 'red white--text'
        }

        if (materia.cursando) {
          color = 'deep-purple darken-1 white--text'
        }

        return color
      }
    }
  }
</script>

<style scoped>
    .materia {
        height: 100px;
        min-width: 100px;
    }

    .red {
        background-color: #B00020 !important;
        border-color: #B00020 !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/information/AvanceReticularPage.vue